import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import { POPOVER_PADDING_X, POPOVER_PADDING_Y, SHEPHERD_PADDING_Y, TOOLTIP_LONGFORM_PADDING } from 'HubStyleTokens/sizes';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { PopoverContext } from '../context/PopoverContext';
import { toPx } from '../utils/Styles';

/** @internal */

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
const handlePadding = (hasStructuredFooter, popoverUse) => {
  if (popoverUse === 'longform') return `0 ${TOOLTIP_LONGFORM_PADDING} ${POPOVER_PADDING_Y}`;
  if (popoverUse === 'shepherd') {
    const paddingTop = hasStructuredFooter ? toPx(parseInt(POPOVER_PADDING_X, 10) - parseInt(SHEPHERD_PADDING_Y, 10)) : '0px';
    const paddingBottom = hasStructuredFooter ? POPOVER_PADDING_Y : SHEPHERD_PADDING_Y;
    return `${paddingTop} ${POPOVER_PADDING_X} ${paddingBottom} ${POPOVER_PADDING_X}`;
  }
  return `${POPOVER_PADDING_Y} ${POPOVER_PADDING_X}`;
};
const Footer = styled.footer.withConfig({
  displayName: "UIPopoverFooter__Footer",
  componentId: "cxqwvq-0"
})(["background:inherit;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0;padding:", ";text-align:", ";", ";"], ({
  flush,
  hasStructuredFooter,
  popoverUse
}) => flush ? '0' : handlePadding(hasStructuredFooter, popoverUse), ({
  align
}) => align, ({
  hasStep
}) => hasStep ? css(["display:flex;justify-content:space-between;align-items:center;"]) : null);
export default function UIPopoverFooter(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Footer, Object.assign({}, rest, {
    className: classNames(className, 'uiPopoverFooter private-popover__footer'),
    popoverUse: useContext(PopoverContext).use
  }));
}
const propTypes = {
  align: PropTypes.oneOf(['left', 'right']).isRequired,
  children: PropTypes.node,
  flush: PropTypes.bool,
  hasStep: PropTypes.bool,
  hasStructuredFooter: PropTypes.bool
};
const defaultProps = {
  align: 'left',
  hasStructuredFooter: false,
  hasStep: false
};
UIPopoverFooter.propTypes = propTypes;
UIPopoverFooter.defaultProps = defaultProps;
UIPopoverFooter.displayName = 'UIPopoverFooter';